<template>
  <div class="payments-app-search-input">
    <UiInputText
      v-model="application"
      static-placeholder
      placeholder="Аккаунт"
      type="text"
      :disabled="true"
      @keyup.enter="runSetUnhandledPayment"
    />

    <div class="row buttons">
      <UiButton
        :disabled="!application"
        :class="['button', 'is-small', 'is-success', { 'is-loading': false }]"
        @click="runSetUnhandledPayment"
      >
        Пополнить
      </UiButton>
      <UiButton
        :disabled="false"
        :class="['button', 'is-small', 'is-danger', { 'is-loading': false }]"
        @click="runDelUnhandledPayment"
      >
        Удалить
      </UiButton>
    </div>
  </div>
</template>

<script>
import UiInputText from '@/components/UiInputText.vue'
import UiButton from '@/components/UiButton.vue'

import { setUnhandledPayment, delPayment } from './PaymentMethods.js'

export default {
  components: {
    UiButton,
    UiInputText,
  },
  props: {
    row: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      application: '',
    }
  },
  methods: {
    runSetUnhandledPayment() {
      if (this.application) setUnhandledPayment.call(this)
    },
    runDelUnhandledPayment() {
      delPayment.call(this)
    },
  },
}
</script>

<style lang="scss" scoped>
.buttons {
  margin: rem(6px) 0 0 0;

  .button {
    width: 100%;

    @include media_custom(1300px) {
      width: auto;
    }

    &:not(:last-child) {
      margin: 0 0 rem(4px) 0;

      @include media_custom(1300px) {
        margin: 0 rem(4px) 0 0;
      }
    }
  }
}
</style>
